import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { authHeader } from "@/lib/aadhaar";

const NAME = "rs_class_name";
const PRESENT = "rs_class_present";
const read = (k, d) => { try { return JSON.parse(localStorage.getItem(k) || "null") ?? d; } catch { return d; } };
export const indiaDate = () => new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10);
export const cleanName = (s) => s.replace(/[^\p{L}\p{M} .'-]/gu, "").replace(/\s+/g, " ").trim().slice(0, 40);
export const getPresent = () => read(PRESENT, {});
export const presentToday = (slug) => getPresent()[slug]?.date === indiaDate();
export const fmtClock = (iso) => new Date(iso).toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit" });

// The student's name: from the Student portal when signed in, otherwise what they typed on this device.
export const useClassName = () => {
  const [name, setName] = useState(() => localStorage.getItem(NAME) || "");
  useEffect(() => {
    if (!localStorage.getItem("rs_student_token")) return;
    api.get("/student/me", authHeader("student")).then((r) => setName(cleanName(r.data.user.name))).catch(() => {});
  }, []);
  const save = (n) => { const c = cleanName(n); localStorage.setItem(NAME, c); setName(c); return c; };
  return { name, first: name.split(" ")[0], save };
};

// Signed-in students are saved on the server (Student portal); guests are remembered on this device.
export async function markPresent(slug) {
  let total = Object.keys(getPresent()).filter((s) => s !== slug).length + 1;
  if (localStorage.getItem("rs_student_token")) {
    try { total = (await api.post("/student/classroom/attendance", { slug }, authHeader("student"))).data.total; } catch (e) { if (e.response?.status !== 401) throw e; }
  }
  const at = new Date().toISOString();
  localStorage.setItem(PRESENT, JSON.stringify({ ...getPresent(), [slug]: { date: indiaDate(), at, total } }));
  return { at, total };
}

export const isStudent = () => Boolean(localStorage.getItem("rs_student_token"));

// Signed-in students: the server computes stars (attendance + graded quiz + real watch time) and issues the 5/5 badge.
export const saveResult = (slug) =>
  isStudent() ? api.post("/student/classroom/result", { slug }, authHeader("student")).then((r) => r.data).catch(() => null) : Promise.resolve(null);

// Watch-time heartbeat every ~10s of playback; the server only credits real-time viewing.
let lastBeat = 0;
export const beatWatch = (slug, pos, force = false) => {
  if (!isStudent() || (!force && Date.now() - lastBeat < 10000)) return Promise.resolve();
  lastBeat = Date.now();
  return api.post("/student/classroom/watch", { slug, pos }, authHeader("student")).catch(() => {});
};

export const downloadNotes = (lesson, cards) => {
  const body = cards.map((c, i) => `${i + 1}. ${c.title}\n${c.points.map((p) => `   - ${p}`).join("\n")}`).join("\n\n");
  const blob = new Blob([`RoboSpark · Lesson ${lesson.n}: ${lesson.title}\nZoya Ma'am ke whiteboard notes\n\n${body}\n`], { type: "text/plain;charset=utf-8" });
  const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(blob), download: `${lesson.slug}-notes.txt` });
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};
